export const SITE_NAME = 'StayInBrowser'
export const SITE_URL = __SITE_URL__.replace(/\/$/, '')
export const SITE_DOMAIN = new URL(`${SITE_URL}/`).hostname
export const SITE_ALTERNATE_NAMES = ['Stay In Browser', SITE_DOMAIN] as const
export const BASE_PATH = __BASE_PATH__
export const ROUTER_BASENAME = BASE_PATH === '/' ? undefined : BASE_PATH.replace(/\/$/, '')
export const SOCIAL_IMAGE_URL = `${SITE_URL}/stayinbrowser-social-preview.jpg`
